// extracted by mini-css-extract-plugin
export default {"card":"Summary_card__R90EQ","cover":"Summary_cover__faVu3","progressCol":"Summary_progressCol__zb9Vs","title":"Summary_title__DyejQ"};